<template>
  <div class="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
    <a href="/" class="mb-8"><img src="/images/logo_testo.png" alt="StreetStock Logo" class="h-12" /></a>
    <h1 class="text-2xl font-bold mb-2">Salva il contatto (2/3)</h1>
    <p class="mb-6 opacity-80">Aggiungi ai contatti il numero del negozio di {{ store.city }}.</p>

    <div class="flex flex-col gap-3 w-full max-w-xs">
      <a href="#" class="btn py-3 rounded-xl font-semibold" @click.prevent="saveVCard">
        Salva contatto
      </a>

      <button class="btn-secondary py-3 rounded-xl font-semibold" :disabled="!saved" :class="{ 'disabled': !saved }"
        @click="next">
        Continua
      </button>

      <a href="/join" class="text-sm opacity-70 mt-2 underline">Cambia negozio</a>
    </div>
  </div>
</template>

<script>
import stores from '@/stores' // <= nuovo

export default {
  name: 'SaveContact',
  data() { return { store: null, saved: false } },
  created() {
    const params = new URLSearchParams(location.search)
    const fromSlug = params.get('store')

    if (fromSlug) {
      const found = stores.find(s => (s.slug || '').toLowerCase() === fromSlug.toLowerCase())
      if (found) {
        this.store = found
        localStorage.setItem('ss_selected_store', JSON.stringify(found))
        return
      }
      // slug non valido: vai alla selezione
      window.location.href = '/join'
      return
    }

    const raw = localStorage.getItem('ss_selected_store')
    if (!raw) { window.location.href = '/join'; return }
    this.store = JSON.parse(raw)
  },
  methods: {
    saveVCard() {
      const tel = `+39${(this.store.phone || '').replace(/\D/g, '')}`
      const name = `StreetStock ${this.store.city}`
      const vcard =
        `BEGIN:VCARD
VERSION:3.0
N:${name};;;;
FN:${name}
ORG:StreetStock Market
TEL;TYPE=CELL:${tel}
NOTE:Contatto ufficiale store ${this.store.city}
END:VCARD`

      const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `streetstock-${this.store.city.toLowerCase().replace(/\s+/g, '-')}.vcf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)

      this.saved = true
    },
    next() { window.location.href = '/join/message' }
  }
}
</script>

<style scoped>
.btn {
  background: #3aa7df;
  color: #fff;
  text-decoration: none;
  transition: .2s;
}

.btn:hover {
  background: #2f93c6;
}

.btn-secondary {
  background: #10b981;
  color: #fff;
  border: none;
}

.btn-secondary.disabled {
  opacity: .45;
  pointer-events: none;
}
</style>
